"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isImmutable = _interopRequireDefault(require("./isImmutable"));

var _isPlainObject = _interopRequireDefault(require("./isPlainObject"));

var _unmutablePredicates = require("../internal/unmutablePredicates");

var _default = function _default(thing) {
  return (0, _isImmutable.default)(thing) || Array.isArray(thing) || (0, _unmutablePredicates.isUnmutableCompatible)(thing) || (0, _isPlainObject.default)(thing);
};

exports.default = _default;